module.exports = __webpack_public_path__ + "img/tp-blue-cir.b26dd319.svg";